import { ItemDiscountWriteCampaignProps } from 'apis/restaurant-api/merchant-admin/campaigns/api';
import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';

import { transformCommonFormFieldsToApi } from './transformCommonFormFieldsToApi';
import { API_UNLIMITED_MAX_DELIVERY_DISTANCE } from '../../components/budget-section/constants';
import { ItemDiscountFormValues } from '../../types';
import { getItemDiscount } from '../getItemDiscount';

// TODO theCybulski: move to more general place
type WithRequiredProperty<Type, Key extends keyof Type> = Type & {
  [Property in Key]-?: Type[Property];
};

export type TransformItemDiscountFormToApiValues = WithRequiredProperty<ItemDiscountFormValues, 'itemTriggerCount'> & {
  currency: Currency;
  merchantId: string;
  venueIds: string[];
  isMultiItemCampaignSupported: boolean;
};

export const transformItemDiscountFormToApi = (
  values: TransformItemDiscountFormToApiValues,
  isEndOfDayCampaign: boolean = false,
): ItemDiscountWriteCampaignProps => ({
  ...transformCommonFormFieldsToApi(values),
  maxDeliveryDistance: API_UNLIMITED_MAX_DELIVERY_DISTANCE, // TODO theCybulski: confirm with BE
  campaignType: CampaignType.ITEM_DISCOUNT,
  itemDiscount: getItemDiscount(values),
  isEndOfDayCampaign,
});
